webpackJsonp([3],{

/***/ 19:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addToCompare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return removeFromCompare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return initCount; });
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var countContainers = document.querySelectorAll('.js-compare-count');

var addToCompare = function addToCompare(productId) {
  var compare = JSON.parse(window.localStorage.getItem('compare')) || [];
  var id = parseInt(productId, 10);
  var included = compare.indexOf(id) >= 0;
  if (!included) {
    compare.push(id);
  }
  updateCount(compare.length);
  window.localStorage.setItem('compare', JSON.stringify(compare));
};

var removeFromCompare = function removeFromCompare(productId) {
  var compare = JSON.parse(window.localStorage.getItem('compare'));
  var id = parseInt(productId, 10);
  var removed = compare.filter(function (item) {
    return item !== id;
  });
  window.localStorage.setItem('compare', JSON.stringify(removed));
  updateCount(removed.length);
};

var updateCount = function updateCount(count) {
  // countContainer.innerHTML = count
};

var initCount = function initCount() {
  if (window.localStorage.getItem('compare')) {
    ;[].concat(_toConsumableArray(countContainers)).forEach(function (countContainer) {
      var compare = JSON.parse(window.localStorage.getItem('compare'));
      countContainer.innerHTML = compare.length;
    });
  }
};

/***/ }),

/***/ 198:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_whatwg_fetch__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_whatwg_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_whatwg_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AddToCompareIcon__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Compare__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_AddToCompareButton__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_compare__ = __webpack_require__(19);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }








// Tell Babel to transform JSX into h() calls:
/** @jsx h */

var addToCompareContainer = document.querySelector('.js-add-to-compare-button');
var compareContainer = document.querySelector('.js-compare');
var countContainers = document.querySelectorAll('.js-compare-count');
var iconContainer = document.querySelectorAll('.js-add-to-compare-icon');

if (compareContainer) {
  var ifempty = compareContainer.dataset.ifempty;

  Object(__WEBPACK_IMPORTED_MODULE_1_preact__["render"])(Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(__WEBPACK_IMPORTED_MODULE_3__components_Compare__["a" /* default */], { ifEmpty: ifempty }), compareContainer);
}

;[].concat(_toConsumableArray(iconContainer)).forEach(function (icon) {
  var id = icon.dataset.id;

  Object(__WEBPACK_IMPORTED_MODULE_1_preact__["render"])(Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(__WEBPACK_IMPORTED_MODULE_2__components_AddToCompareIcon__["a" /* default */], { id: id }), icon);
});

if (countContainers.length) {
  Object(__WEBPACK_IMPORTED_MODULE_5__helpers_compare__["b" /* initCount */])();
}

/***/ }),

/***/ 199:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_compare__ = __webpack_require__(19);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



// Tell Babel to transform JSX into h() calls:
/** @jsx h */

var AddToCompareIcon = function (_Component) {
  _inherits(AddToCompareIcon, _Component);

  function AddToCompareIcon() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AddToCompareIcon);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AddToCompareIcon.__proto__ || Object.getPrototypeOf(AddToCompareIcon)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isCurrentProductAdded: null,
      announcement: '',
      count: 0
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AddToCompareIcon, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var compare = window.localStorage.getItem('compare');
      if (compare) {
        var array = JSON.parse(compare);
        var included = array.indexOf(parseInt(this.props.id, 10)) >= 0;
        this.setState({ count: array.length });
        this.setState({
          isCurrentProductAdded: included
        });
      }
    }
  }, {
    key: 'addProduct',
    value: function addProduct(productId) {
      var _this2 = this;

      Object(__WEBPACK_IMPORTED_MODULE_1__helpers_compare__["a" /* addToCompare */])(productId);
      var compare = window.localStorage.getItem('compare');
      var array = JSON.parse(compare);
      if (array.length > 1) {
        window.location = '/vergelijk';
      } else {
        this.setState({ announcement: 'Voeg nog 1 product toe' });
      }
      this.setState(function (prevState) {
        return {
          isCurrentProductAdded: !prevState.isCurrentProductAdded
        };
      });
      window.setTimeout(function () {
        _this2.setState({
          announcement: ''
        });
      }, 3000);
    }
  }, {
    key: 'removeProduct',
    value: function removeProduct(productId) {
      this.setState(function (prevState) {
        return {
          isCurrentProductAdded: !prevState.isCurrentProductAdded
        };
      });
      Object(__WEBPACK_IMPORTED_MODULE_1__helpers_compare__["c" /* removeFromCompare */])(productId);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      if (!this.state.isCurrentProductAdded) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'button',
          {
            'class': 'u-clean-button c-product-popup__compare-button',
            onClick: function onClick() {
              _this3.addProduct(_this3.props.id);
            }
          },
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'span',
            { className: 'c-product-hero__compare-text' },
            'vergelijk'
          ),
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('svg', {
            className: 'c-icon c-product-hero__compare-icon',
            dangerouslySetInnerHTML: {
              __html: '<use xlink:href="#compare"></use>'
            }
          }),
          this.state.announcement != '' ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('span', {
            className: 'c-product-popup__compare-announce',
            dangerouslySetInnerHTML: { __html: this.state.announcement }
          }) : null
        );
      } else {
        return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'button',
          {
            'class': 'u-clean-button c-product-popup__compare-button c-product-popup__compare-button--fill',
            onClick: function onClick() {
              _this3.removeProduct(_this3.props.id);
            }
          },
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'span',
            { className: 'c-product-hero__compare-text' },
            'verwijder'
          ),
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('svg', {
            className: 'c-icon c-product-hero__compare-icon',
            dangerouslySetInnerHTML: {
              __html: '<use xlink:href="#compare"></use>'
            }
          }),
          this.state.announcement != '' ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('span', {
            className: 'c-product-popup__compare-announce',
            dangerouslySetInnerHTML: { __html: this.state.announcement }
          }) : null
        );
      }
    }
  }]);

  return AddToCompareIcon;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (AddToCompareIcon);

/***/ }),

/***/ 200:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProductGrid__ = __webpack_require__(201);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



// Tell Babel to transform JSX into h() calls:
/** @jsx h */

var API_URL = document.querySelector('link[rel="https://api.w.org/"]').href;

var Compare = function (_Component) {
  _inherits(Compare, _Component);

  function Compare() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Compare);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Compare.__proto__ || Object.getPrototypeOf(Compare)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      products: [],
      count: 0
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Compare, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var items = JSON.parse(window.localStorage.getItem('compare')) || [];
      if (items.length) {
        window.fetch('/wp-json/wp/v2/products?include=' + items.join(','), {
          credentials: 'same-origin'
        }).then(function (r) {
          return r.json();
        }).then(function (r) {
          return _this2.setState({ products: r });
        }).catch(function (e) {
          return console.error(e);
        });
      }
      this.setProductCount();
    }
  }, {
    key: 'setProductCount',
    value: function setProductCount() {
      var items = JSON.parse(window.localStorage.getItem('compare')) || [];
      this.setState({
        count: items.length
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          products = _state.products,
          count = _state.count;

      return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'section',
        { style: 'width: 100%;' },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'h2',
          {
            style: {
              display: 'inline-block',
              width: '100%',
              textAlign: 'center'
            }
          },
          'Vergelijk',
          count > 0 ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'div',
            { 'class': 'c-single-product__count' },
            count,
            ' ',
            count === 1 ? 'product' : 'producten'
          ) : null
        ),
        count ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1__ProductGrid__["a" /* default */], {
          products: products,
          setProductCount: function setProductCount() {
            return _this3.setProductCount();
          }
        }) : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', {
          style: {
            display: 'inline-block',
            marginRight: '1rem',
            width: '100%',
            textAlign: 'center'
          },
          dangerouslySetInnerHTML: { __html: this.props.ifEmpty }
        })
      );
    }
  }]);

  return Compare;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Compare);

/***/ }),

/***/ 201:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProductPreview__ = __webpack_require__(202);


// Tell Babel to transform JSX into h() calls:
/** @jsx h */

var ProductGrid = function ProductGrid(_ref) {
  var products = _ref.products,
      setProductCount = _ref.setProductCount;

  var gridClass = products.length > 2 ? 'c-product-grid c-product-grid--sb' : 'c-product-grid';
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'div',
    { className: gridClass, style: { margin: '2rem 0' } },
    products.map(function (product) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1__ProductPreview__["a" /* default */], {
        key: product.id,
        setProductCount: setProductCount,
        product: product
      });
    })
  );
};

/* harmony default export */ __webpack_exports__["a"] = (ProductGrid);

/***/ }),

/***/ 202:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_compare__ = __webpack_require__(19);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



// Tell Babel to transform JSX into h() calls:
/** @jsx h */

var ProductPreview = function (_Component) {
  _inherits(ProductPreview, _Component);

  function ProductPreview() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ProductPreview);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ProductPreview.__proto__ || Object.getPrototypeOf(ProductPreview)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isRemoved: false
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ProductPreview, [{
    key: 'handleRemove',
    value: function handleRemove(e, id) {
      e.preventDefault();
      this.setState({
        isRemoved: true
      });
      // Remove from compare
      Object(__WEBPACK_IMPORTED_MODULE_1__helpers_compare__["c" /* removeFromCompare */])(id);
      // Reset product count
      this.props.setProductCount();
    }
  }, {
    key: 'handleClick',
    value: function handleClick(e) {
      var dropdownLists = document.querySelectorAll('.js-options-list');
      var dropdownTitles = document.querySelectorAll('.js-options-title');[].concat(_toConsumableArray(dropdownLists)).forEach(function (dropdown) {
        if (dropdown.classList.contains('c-single-product__options--active')) {
          dropdown.classList.remove('c-single-product__options--active');
        } else {
          dropdown.classList.add('c-single-product__options--active');
        }
      });[].concat(_toConsumableArray(dropdownTitles)).forEach(function (title) {
        if (title.classList.contains('c-single-product__list-title--active')) {
          title.classList.remove('c-single-product__list-title--active');
        } else {
          title.classList.add('c-single-product__list-title--active');
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var product = this.props.product;

      if (this.state.isRemoved) return null;
      var specs = product.product_details.specs ? product.product_details.specs : [];
      var options = product.product_details.options ? product.product_details.options : [];

      return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        { className: 'c-single-product c-single-product--compare' },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'div',
          { className: 'c-single-product__inner' },
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'div',
            { className: 'c-single-product__top-bar u-flex u-flex-sb u-flex-v-center' },
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              'h3',
              { className: 'c-single-product__title' },
              product.title.rendered
            ),
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              'button',
              {
                className: 'c-single-product__remove-button u-clean-button',
                onClick: function onClick(e) {
                  return _this2.handleRemove(e, product.id);
                }
              },
              Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'span',
                { 'class': 'c-single-product__remove-content' },
                'verwijder'
              ),
              Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('svg', {
                className: 'c-icon c-icon--small c-single-product__icon',
                dangerouslySetInnerHTML: {
                  __html: '<use xlink:href="#close-2"></use>'
                }
              })
            )
          ),
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'div',
            { className: 'c-single-product__container' },
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              'div',
              { className: 'c-single-product__image' },
              Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', {
                className: 'c-single-product__background o-background',
                style: { backgroundImage: 'url(' + product.thumbnail + ')' }
              })
            ),
            specs.length > 0 ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              'div',
              { className: 'c-single-product__list' },
              Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'div',
                { className: 'c-single-product__list-title' },
                'Specificaties'
              ),
              Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'ul',
                { className: 'c-single-product__specs' },
                specs.map(function (spec) {
                  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('li', {
                    className: 'c-single-product__spec',
                    dangerouslySetInnerHTML: { __html: spec.spec }
                  });
                })
              )
            ) : null,
            options.length > 0 ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              'div',
              { className: 'c-single-product__list' },
              Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'div',
                {
                  className: 'c-single-product__list-title c-single-product__list-title--options js-options-title',
                  onClick: this.handleClick
                },
                ' ',
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('svg', {
                  className: 'c-icon c-icon--small c-single-product__chevron',
                  dangerouslySetInnerHTML: {
                    __html: '<use xlink:href="#chevron-right"></use>'
                  }
                }),
                ' ',
                'Opties'
              ),
              Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'ul',
                { className: 'c-single-product__specs c-single-product__options js-options-list' },
                options.map(function (option) {
                  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('li', {
                    className: 'c-single-product__spec',
                    dangerouslySetInnerHTML: { __html: option.option }
                  });
                })
              )
            ) : null,
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              'div',
              { className: 'c-single-product__button-container' },
              product.buttons.map(function (button, index) {
                var buttonClass = index === 0 ? 'c-button c-button--primary c-single-product__button' : 'c-button c-button--secondary c-single-product__button';
                return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                  'a',
                  { href: button.url, className: buttonClass },
                  button.content,
                  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('svg', {
                    className: 'c-icon c-icon--xsmall c-button__icon',
                    dangerouslySetInnerHTML: {
                      __html: '<use xlink:href="#arrow-right-thin"></use>'
                    }
                  }),
                  index === 0 ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                    'div',
                    { className: 'c-pulse' },
                    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', { className: 'c-pulse__inner' })
                  ) : null
                );
              })
            )
          )
        )
      );
    }
  }]);

  return ProductPreview;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (ProductPreview);

/***/ }),

/***/ 203:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_compare__ = __webpack_require__(19);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



// Tell Babel to transform JSX into h() calls:
/** @jsx h */

var AddToWishListButton = function (_Component) {
  _inherits(AddToWishListButton, _Component);

  function AddToWishListButton() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AddToWishListButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AddToWishListButton.__proto__ || Object.getPrototypeOf(AddToWishListButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isCurrentProductAdded: null
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AddToWishListButton, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var compare = window.localStorage.getItem('compare');
      if (compare) {
        var array = JSON.parse(compare);
        var included = array.indexOf(parseInt(this.props.id, 10)) >= 0;
        this.setState({
          isCurrentProductAdded: included
        });
      }
    }
  }, {
    key: 'addProduct',
    value: function addProduct(productId) {
      this.setState(function (prevState) {
        return {
          isCurrentProductAdded: !prevState.isCurrentProductAdded
        };
      });
      Object(__WEBPACK_IMPORTED_MODULE_1__helpers_compare__["a" /* addToCompare */])(productId);
    }
  }, {
    key: 'removeProduct',
    value: function removeProduct(productId) {
      this.setState(function (prevState) {
        return {
          isCurrentProductAdded: !prevState.isCurrentProductAdded
        };
      });
      Object(__WEBPACK_IMPORTED_MODULE_1__helpers_compare__["c" /* removeFromCompare */])(productId);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      if (!this.state.isCurrentProductAdded) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'a',
          {
            className: 'c-product-intro-content__compare-link',
            onClick: function onClick() {
              _this2.addProduct(_this2.props.id);
            }
          },
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('svg', {
            className: 'c-icon c-icon--medium',
            dangerouslySetInnerHTML: {
              __html: '<use xlink:href="#compare"></use>'
            }
          }),
          'vergelijk'
        );
      } else {
        return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'div',
          null,
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'a',
            {
              className: 'c-product-intro-content__compare-link c-product-intro-content__compare-link--cross',
              onClick: function onClick() {
                _this2.removeProduct(_this2.props.id);
              }
            },
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('svg', {
              className: 'c-icon c-icon--xsmall',
              dangerouslySetInnerHTML: {
                __html: '<use xlink:href="#compare"></use>'
              }
            }),
            'verwijder uit vergelijking'
          )
        );
      }
    }
  }]);

  return AddToWishListButton;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/* unused harmony default export */ var _unused_webpack_default_export = (AddToWishListButton);

/***/ })

},[198]);


// WEBPACK FOOTER //
// compare.95c46a48b9b7216d9adc.js